export default __webpack_public_path__ + "static/monday-12dc62556f6319a37f247ed6c0016672.png";